import script from "./DefAiButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefAiButtons.vue?vue&type=script&lang=ts&setup=true"

import "./DefAiButtons.vue?vue&type=style&index=0&id=791d124a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-791d124a"]])

export default __exports__